import { Typography } from 'kl-b2c-ui-kit';
import styled, { css } from 'styled-components';
import { colorWhite, mediaSm } from 'theme/theme-helper-selectors';

export const Content = styled.div<{ showBorder: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 0px 20px 0px 0px;
    margin-right: 20px;
    @media (${mediaSm}) {
        border-right: none;
        border-bottom: 1px solid ${colorWhite};
        padding: 20px 0px 20px 0px;
    }
    ${({ showBorder }) =>
        showBorder &&
        css`
            border-right: 1px solid ${colorWhite};
        `};
`;

export const Image = styled.div<{ image: string }>`
    width: 60px;
    height: 60px;
    background-image: url(${({ image }) => image});
    background-repeat: no-repeat;
    background-size: contain;
    padding-bottom: 20px;
    @media (${mediaSm}) {
        width: 46px;
        height: 46px;
    }
`;

export const Description = styled(Typography)`
    padding-top: 20px;
    color: ${colorWhite};
`;
